import React from "react";
import { FiSearch, FiX, FiAlertCircle, FiEye, FiZap, FiCpu, FiLayers } from "react-icons/fi";
import { Section, SearchField, ChipScroll, Chip, LoadMore } from "../styles";
import { SegmentedControl, Avatar } from "./primitives";
import Feed from "./Feed";
import { IOS, moduleMeta } from "../labels";

export default function Timeline({
  items, total, loading, loadingMore, onLoadMore, onSelect,
  filters, setFilters, search, setSearch, modules, lookup,
}) {
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: f[k] === v ? "" : v }));
  const user = filters.userId ? lookup.users[filters.userId] : null;
  const project = filters.projectId ? lookup.projects[filters.projectId] : null;

  return (
    <Section $first>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <SearchField $max="460px">
          <FiSearch />
          <input placeholder="Buscar por usuário, projeto, ação ou operação" value={search} onChange={(e) => setSearch(e.target.value)} />
          {search && <button className="clear" onClick={() => setSearch("")}><FiX /></button>}
        </SearchField>
        <div style={{ flex: 1 }} />
        <SegmentedControl
          small
          value={filters.type || "all"}
          onChange={(k) => setFilters((f) => ({ ...f, type: k === "all" ? "" : k }))}
          options={[
            { key: "all", icon: <FiLayers />, label: "Tudo" },
            { key: "action", icon: <FiZap />, label: "Ações" },
            { key: "page_view", icon: <FiEye />, label: "Telas" },
            { key: "task", icon: <FiCpu />, label: "Tarefas" },
          ]}
        />
      </div>

      <ChipScroll>
        {user && (
          <Chip $active $color={user.color || IOS.green} onClick={() => setFilters((f) => ({ ...f, userId: "" }))}>
            <Avatar id={filters.userId} name={user.name} color={user.color} size={18} /> {user.name} <FiX />
          </Chip>
        )}
        {project && (
          <Chip $active $color={project.color || IOS.indigo} onClick={() => setFilters((f) => ({ ...f, projectId: "" }))}>
            <Avatar id={filters.projectId} name={project.name} color={project.color} size={18} square /> {project.name.split(" ").slice(0, 3).join(" ")} <FiX />
          </Chip>
        )}
        <Chip $active={filters.status === "error"} $color={IOS.red} onClick={() => set("status", "error")}>
          <FiAlertCircle /> Somente erros
        </Chip>
        {modules.filter((m) => m !== "navigation" && m !== "worker").map((m) => {
          const meta = moduleMeta(m);
          const Icon = meta.icon;
          return (
            <Chip key={m} $active={filters.module === m} $color={meta.color} onClick={() => set("module", m)}>
              <Icon /> {meta.label}
            </Chip>
          );
        })}
      </ChipScroll>

      <div style={{ marginTop: 14 }}>
        <Feed items={items} loading={loading} onSelect={onSelect} />
      </div>

      {!loading && items.length < total && (
        <LoadMore onClick={onLoadMore} disabled={loadingMore}>
          {loadingMore ? "Carregando..." : `Mostrar mais · ${(total - items.length).toLocaleString("pt-BR")} restantes`}
        </LoadMore>
      )}
    </Section>
  );
}
